import http from '@/services/rest/rest.service';
import {ILinkModel, IGetLinkModel, ILinkParamsModel} from '@/entities';

export default {
    list(body: IGetLinkModel): Promise<ILinkModel[]> {
        return http.post('links/list', body);
    },
    decrypt(cryptData: string): Promise<ILinkParamsModel> {
        return http.get(`links/decrypt/${cryptData}`);
    }
};
